import { render, staticRenderFns } from "./TripsReportMobile.vue?vue&type=template&id=848d3d94&scoped=true&"
import script from "./TripsReportMobile.vue?vue&type=script&lang=js&"
export * from "./TripsReportMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848d3d94",
  null
  
)

export default component.exports